import { Component, OnInit } from '@angular/core';
import { SessionService } from '@app/shared/helpers/index';
import { AuthService as Auth0Service } from '@auth0/auth0-angular';
import { datadogRum } from '@datadog/browser-rum';
@Component({
  selector: '',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
})
export class LogoutComponent implements OnInit {
  constructor(private sessionService: SessionService, private auth0Service: Auth0Service) {}

  ngOnInit() {
    datadogRum.stopSessionReplayRecording();
    this.auth0Service.logout({ logoutParams: { returnTo: document.location.origin } });
    this.sessionService.expireSession();
  }
}
